<template>
  <!-- 全部订单：不限负责人，展示全量订单 -->
  <OrderList />
</template>

<script lang="ts" setup>
import OrderList from '../components/OrderList.vue'

defineOptions({ name: 'CrmOrderAll' })
</script>
